/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import axios from 'axios'
import {getUserByToken} from '../../../../app/modules/auth/core/_requests'
import {API_URL} from '../../../../app/modules/auth/core/_requests'

const HeaderUserMenu: FC = () => {
  const {auth, currentUser, logout, saveAuth, setCurrentUser} = useAuth()

  const changeVendor = async (vendorName: string) => {
    console.log('Changing vendor to:', vendorName)
    try {
      const response = await axios.post(
        `${API_URL}/users/update_vendor`,
        {vendorName},
        {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          },
        }
      )
      const {api_token} = response.data
      saveAuth({api_token})
      // Fetch the updated user data
      const {data: user} = await getUserByToken(api_token)
      setCurrentUser(user)
      // Optionally, reload the page
      window.location.reload()
    } catch (error) {
      console.error('Error changing vendor:', error)
      // Handle the error, possibly show a notification to the user
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-450px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <i className='bi bi-person-fill'></i>
          </div>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.decoded?.email}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                {currentUser?.decoded?.role}
              </span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.decoded?.vendorName}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {currentUser?.decoded?.role === 'admin' ? (
        <>
          {/* Main Dropdown: Change Vendor View */}
          <div
            className='menu-item px-5'
            data-kt-menu-trigger='hover'
            data-kt-menu-placement='left-start'
            data-kt-menu-flip='bottom'
          >
            <a href='#' className='menu-link px-5'>
              <span className='menu-title'>Change Vendor View</span>
              <span className='menu-arrow'></span>
            </a>

            <div className='menu-sub menu-sub-dropdown w-250px py-4'>
              {/* Primary Vendor Options */}
              <div className='menu-item px-3'>
                <a
                  href='#'
                  className='menu-link px-5'
                  onClick={() => changeVendor('Designer Eyes')}
                >
                  Designer Eyes
                </a>
              </div>
              <div className='menu-item px-3'>
                <a href='#' className='menu-link px-5' onClick={() => changeVendor('Luxottica')}>
                  Luxottica
                </a>
              </div>
              <div className='menu-item px-3'>
                <a href='#' className='menu-link px-5' onClick={() => changeVendor('Thelios')}>
                  Thelios
                </a>
              </div>
              <div className='menu-item px-3'>
                <a href='#' className='menu-link px-5' onClick={() => changeVendor('Costa')}>
                  Costa
                </a>
              </div>

              {/* Nested Dropdown: Store Views */}
              <div
                className='menu-item px-3'
                data-kt-menu-trigger='hover'
                data-kt-menu-placement='right-start'
              >
                <a href='#' className='menu-link px-5'>
                  <span className='menu-title'>Store Views</span>
                  <span className='menu-arrow'></span>
                </a>
                <div className='menu-sub menu-sub-dropdown w-250px py-4'>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R001 - POV Sawgrass')}
                    >
                      R001 - POV Sawgrass
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R002 - Just One Look')}
                    >
                      R002 - Just One Look
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R003 - Eyes on Lincoln')}
                    >
                      R003 - Eyes on Lincoln
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R004 - PV2 Dolphin')}
                    >
                      R004 - PV2 Dolphin
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R005 - DE Mall of San Juan')}
                    >
                      R005 - DE Mall of San Juan
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R006 - DE Brickell')}
                    >
                      R006 - DE Brickell
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R008 - DE Florida Mall')}
                    >
                      R008 - DE Florida Mall
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R009 - Aventura')}
                    >
                      R009 - Aventura
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R010 - PV3 iDrive')}
                    >
                      R010 - PV3 iDrive
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R011 - PV4 Vineland')}
                    >
                      R011 - PV4 Vineland
                    </a>
                  </div>
                  <div className='menu-item px-3'>
                    <a
                      href='#'
                      className='menu-link px-5'
                      onClick={() => changeVendor('R014 - DE Plaza Las Americas')}
                    >
                      R014 - DE Plaza Las Americas
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}

      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
